const ITEMS = [
  "Aroma Therapy",
  "Balinese Massage",
  "Deep Tissue",
  "Thai Therapy",
  "Four Hand Massage",
  "Body Massage",
  "Jacuzzi Spa",
  "Suchitra · Hyderabad",
];

export const Marquee = () => (
  <div
    className="relative overflow-hidden border-y border-amber-500/10 bg-[#0D0D0F] py-6"
    data-testid="editorial-marquee"
  >
    <div className="marquee-track flex w-max whitespace-nowrap">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="font-display text-2xl md:text-4xl font-light italic text-stone-500/90 px-10">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rotate-45 bg-amber-500/50" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
